import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMaskModule } from 'ngx-mask';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'personal-data',
    templateUrl: './personal-data.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        NgxMaskModule
    ]
})
export class PersonalDataComponent implements OnInit {
    userData: any;
    loading: boolean = true;

    constructor(
        private _authService: AuthService
    ) {}

    ngOnInit(): void {
        // Simula um pequeno delay para mostrar o skeleton
        setTimeout(() => {
            // Carrega os dados do usuário do localStorage
            this.userData = JSON.parse(this._authService.getLSUser);
            console.log('User Data:', this.userData);
            this.loading = false;
        }, 500);
    }
}
